import { render, staticRenderFns } from "./BsCombobox.vue?vue&type=template&id=02900464&"
import script from "./BsCombobox.vue?vue&type=script&lang=js&"
export * from "./BsCombobox.vue?vue&type=script&lang=js&"
import style0 from "./BsCombobox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports